<div class="version" (click)="openVersionModal()">
    <fa-icon [icon]="faInfoCircle" class="nav-icon" [fixedWidth]="true"></fa-icon>
    <span *ngIf="navigationService.navbarStatus !== NavbarStatus.MINIMISED">
        v{{version}} &#64; {{year}}
    </span>
</div>